import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import styles from "./styles.module.css";

const ManualProcuracao = ({ open, onClose }) => {
  return (
    <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth>
      <DialogContent>
        <div className={styles.container}>
          <h2 className={styles.title}>Manual de Geração de Procuração</h2>
          <p className={styles.subtitle}>
            Para gerar uma procuração válida, siga os passos abaixo:
          </p>

          <hr className={styles.divider} />

          <h3 className={styles.stepTitle}>1. Acesse o Portal e-CAC</h3>
          <p className={styles.stepDescription}>
            🔗{" "}
            <a
              href="https://cav.receita.fazenda.gov.br/autenticacao/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Clique aqui para acessar o e-CAC
            </a>
          </p>

          <hr className={styles.divider} />

          <h3 className={styles.stepTitle}>2. Configure a procuração</h3>

          <h4 className={styles.subStep}>1️⃣ No menu do e-CAC, selecione:</h4>
          <ul className={styles.list}>
            <li>
              <strong>Senhas e Procurações</strong>
            </li>
            <li>
              <strong>Procuração para e-CAC</strong>
            </li>
          </ul>

          <h4 className={styles.subStep}>
            2️⃣ Informe o CNPJ da Taxation Mind:
          </h4>
          <p className={styles.cnpj}>
            <strong>26.517.419/0001-09</strong>
          </p>

          <h4 className={styles.subStep}>3️⃣ Defina a vigência:</h4>
          <p className={styles.stepDescription}>
            No mínimo <strong>60 dias</strong>
          </p>

          <h4 className={styles.subStep}>4️⃣ Selecione os seguintes itens:</h4>

          <h5 className={styles.category}>📌 Acesso ao e-Social</h5>
          <ul className={styles.list}>
            <li>E Social – Grupo acesso web</li>
            <li>E Social – Download</li>
          </ul>

          <h5 className={styles.category}>📌 DCTF e PER/DCOMP</h5>
          <ul className={styles.list}>
            <li>Acessar o sistema DCTFWeb</li>
            <li>Acessar PER/DCOMP Web</li>
            <li>PER/DCOMP – Consulta Processamento</li>
            <li>PER/DCOMP – Consulta Intimação</li>
            <li>PER/DCOMP – Consulta Despacho Decisório</li>
            <li>PER/DCOMP – Consulta Análise Preliminar/Auto Regularização</li>
          </ul>

          <h5 className={styles.category}>📌 Download de Documentos</h5>
          <ul className={styles.list}>
            <li>
              Download da Escrituração Fiscal Digital (SPED – EFD) via
              ReceitanetBx
            </li>
            <li>Download de EFD Pis/Cofins via ReceitanetBx</li>
            <li>
              Download dos arquivos SPED (dados agregados e termos de ECD) via
              ReceitanetBx
            </li>
            <li>
              Download da Escrituração Contábil Digital (SPED-ECD) via
              ReceitanetBx
            </li>
            <li>SPED-ECF (Escrituração Contábil Fiscal)</li>
            <li>SPED-ECF-Download via ReceitanetBX</li>
          </ul>

          <h5 className={styles.category}>📌 Consulta e Comunicação</h5>
          <ul className={styles.list}>
            <li>Caixa Postal – Mensagens</li>
            <li>Consulta Pendências – Inclusão no Cadin/Sisbacen pela RFB</li>
            <li>
              CHATRFB – Todos os serviços disponíveis no canal de atendimento
            </li>
            <li>Situação Fiscal do Contribuinte</li>
            <li>Processos Digitais e Requerimentos Web</li>
          </ul>

          <h5 className={styles.category}>📌 Pagamentos e Declarações</h5>
          <ul className={styles.list}>
            <li>PGF – Consulta Débitos Inscritos a partir de 01/11/2012</li>
            <li>PGFN – Consulta Débitos Inscritos a partir de 01/11/2012</li>
            <li>Pagamentos – Comprovante de Arrecadação</li>
            <li>
              Declarações - DCTF (Acesso ao conteúdo, extrato e 2ª via do
              recibo)
            </li>
            <li>Cópia de Declaração</li>
            <li>
              Transmissão de Declarações/Arquivos (inclusive CNPJ) com
              Assinatura Digital via Receitanet
            </li>
          </ul>
        </div>
          <div>
            <Button
              onClick={onClose}
              variant="outlined"
              className={styles.btn_close}
            >
              Fechar
            </Button>
          </div>
      </DialogContent>
    </Dialog>
  );
};

export default ManualProcuracao;
